
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18 13H12.94C12.6 16.1 10.68 18.72 8.00001 20.05C7.97001 21.86 6.34 23.28 4.45001 22.95C3.25001 22.74 2.26001 21.75 2.05001 20.55C1.71001 18.65 3.16001 17 5.00001 17C5.95001 17 6.78 17.45 7.33001 18.14C9.23001 17.11 10.59 15.23 10.91 13H7.81001C7.33001 14.34 5.95001 15.24 4.39001 14.94C3.21001 14.71 2.26001 13.74 2.04001 12.56C1.70001 10.66 3.16001 9 5.00001 9C6.3 9 7.40001 9.84 7.82001 11H10.92C10.6 8.77 9.23001 6.9 7.33001 5.86C6.69001 6.66 5.66001 7.14 4.52001 6.96C3.29001 6.77 2.26001 5.77 2.05001 4.54C1.72001 2.65 3.17001 1 5.00001 1C6.64001 1 7.96 2.31 7.99001 3.95C10.67 5.28 12.59 7.9 12.93 11H18V9.21C18 8.76 18.54 8.54 18.85 8.86L21.64 11.65C21.84 11.85 21.84 12.16 21.64 12.36L18.85 15.15C18.54 15.46 18 15.24 18 14.79V13Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-mediation`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMediation

    ```js
    <b-new-b-icon-mediation />
    ```
</docs>


